import { EventEmitter } from "pixi.js";


export enum EnumEventBus {
  setPlayAmount = "SET_PLAY_AMOUNT",
  setSettingsPopup = "SET_SETTINGS_POPUP",
  setAutoplayPopup = "SET_AUTOPLAY_POPUP",
  setAutoplayGame = "SET_AUTOPLAY_GAME",
  setAutoPlayCount = "SET_AUTOPlAY_COUNT",
  showBonus = "SHOW_BONUS",
  startTransitionAnim1 = "START_TRANSITION_ANIMATION_1",
  startTransitionAnim2 = "START_TRANSITION_ANIMATION_2",
  setTranstionAnim2 = "SET_TRANSTION_ANIMATION_2",
  logoAnimAllsuper = "LOGO_ANIMATION_ALL_SUPER"
}


export const EventBus = new EventEmitter();